/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * VideoPlayIcon - Auto-generated from icon.js
 */
export const VideoPlayIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none" {...props}>
		<circle cx="20" cy="20" r="20" fill="black" fillOpacity="0.5" />
		<path fillRule="evenodd" clipRule="evenodd" d="M27.9509 19.2988L16.2842 11.7988C16.0287 11.632 15.6983 11.623 15.4346 11.7679C15.166 11.9144 15 12.1944 15 12.4995V27.4995C15 27.8047 15.166 28.0847 15.4346 28.2312C15.5583 28.2987 15.6966 28.3329 15.8334 28.3329C15.9896 28.3329 16.1475 28.2889 16.2842 28.2002L27.9509 20.7002C28.1885 20.5473 28.3334 20.2827 28.3334 19.9995C28.3334 19.7163 28.1885 19.4519 27.9509 19.2988Z" fill="white" />
	</svg>
);

export default VideoPlayIcon;
